import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IBrowseExperienceButtonProps } from '../BrowseExperienceButton.types';
import { BrowseExperienceButton } from '../BrowseExperienceButton';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IBrowseExperienceButtonProps = elementAttributesToProps(domNode);

  return Promise.resolve(<BrowseExperienceButton {...props} />);
};

export default rehydrator;
